import React from "react";

type LoadingSpinnerProps = {
    size?: number;
    spinnerColor?: string; // border-t-*
    textColor?: string;    // text-*
    className?: string;
    text?: string;
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    size = 32,
    spinnerColor = "border-t-blue-500",
    textColor = "text-blue-500",
    className = "",
    text = "Đang tải...",
}) => {
    return (
        <div className={`flex flex-col items-center justify-center gap-2 py-10 ${className}`}>
            <div
                className={`border-4 border-gray-300 ${spinnerColor} rounded-full animate-spin`}
                style={{ width: size, height: size }}
            />
            <p className={`text-xl font-medium ${textColor}`}>
                {text}
            </p>
        </div>
    );
};

export default LoadingSpinner;